<template>
 <div class="recommend-card-base">
   <a :href="tgtItem.url">
     <div class="image"><img :src="imagePath" /></div>
     <h4>{{ articleTitle }}</h4>
     <span class="counselor">占い師：{{ tgtItem.counselor_name }}</span>
     <ul>
       <li v-if="tgtItem.services_name">{{ tgtItem.services_name }}</li>
       <li v-if="tgtItem.category_tag_name">{{ tgtItem.category_tag_name }}</li>
     </ul>
     <span class="price">￥{{ tgtItem.price_taxin | commaFormat }}<span class="taxlabel">（税込）</span></span>
   </a>
 </div>
</template>

<script>
import articleCardHeader from './articleCardHeader'
export default {
  name: "ArticleCard",
  components: { articleCardHeader },
  props: {
    tgtItem: {
      type: Object,
      default() {
        return {}
      }
    },
    idx: {
      type: Number,
      default() {
        return 0
      }
    },
    isLarge: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    imagePath() {
      return this.tgtItem.pack_image
    },
    articleTitle() {
      return this.tgtItem.item_name
    },
    targetId() {
      return this.tgtItem.textItemId
    }
  },
  methods: {
    onDetailBtnClick() {
      if(this.tgtItem.url != null && this.tgtItem.url.length > 0 ) {
        location.href = this.tgtItem.url
      }
    }
  },
  filters: {
    commaFormat(val){
      return String(val).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }


}</script>

<style scoped lang="scss">
@import "../../../../../../sass/variables/index";
.recommend-card-base {
  a {
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer;
    text-decoration: none;
    color: $gray-20;
    $imgW: 104px;
    $outerPaddingH: 25px;
    $outerPaddingV: 12px;
    $imgMargin: 20px;
    width: 100%;
    height: $imgW  +$outerPaddingV + $outerPaddingV;
    padding: $outerPaddingV 0 $outerPaddingV ($imgW + $imgMargin);
    position: relative;
    color: $gray-20;
    .image {
      width: $imgW;
      height: $imgW;
      position: absolute;
      top: $outerPaddingV;
      left: 0;
      border-radius: 5px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    h4 {
      font-size: 12px;
      line-height: 18px;
      margin: 0 0 4px;
      width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      overflow: hidden;
    }
    .counselor {
      display: block;
      font-size: 12px;
      width: 100%;
      margin-bottom: 4px;
    }
    & > ul {
      list-style: none;
      padding: 0;
      margin: 0;
      & > li {
        font-size: 10px;
        padding: 1px 4px 0;
        border: 1px solid $gray-22;
        display: inline-block;
      }
    }
    .price {
      display: inline-block;
      font-weight: bold;
      font-size: 14px;
      position: absolute;
      bottom: 6px;
      right: 0;
      .taxlabel {
        font-size: 11px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/recommendCard.vue